import { render, staticRenderFns } from "./EditorPage.vue?vue&type=template&id=8230cc58&"
import script from "./EditorPage.vue?vue&type=script&lang=js&"
export * from "./EditorPage.vue?vue&type=script&lang=js&"
import style0 from "./EditorPage.vue?vue&type=style&index=0&id=8230cc58&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VChip } from 'vuetify/lib/components/VChip';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
installComponents(component, {VBtn,VCard,VChip,VProgressCircular})
